import React from 'react'
import styled from 'styled-components'

class ExpandSidebarIcon extends React.Component {
  render() {
    const showIcon = this.props.docked ? 'none' : 'flex'
    const align = this.props.left ? 'left' : 'right'
    const StyledImg = styled.img`
      height: 20px;
      width: 20px;
  &:hover {
    cursor: pointer;
  }
    `

    const StyledDiv = styled.div`
      color: black;
      border: 2px solid rgba(0, 0, 0, 0.75);
      border-top: 2px solid rgba(0, 0, 0, 0.3);
      background-color: white;
      width: 30px;
      position: relative;
      height: 100%;
      justify-content: center;
      align-items: flex-start;
      align-content: center;
      position: fixed;
      padding: 15px 5px 0px 5px;
      ${align}: 0;
      display: ${showIcon};
      z-index: 1;
    `
    return (
      <StyledDiv onClick={this.props.toggleDocked}>
        <StyledImg src="/static/expand.png" />
      </StyledDiv>
    )
  }
}

export default ExpandSidebarIcon
